/* Newsletter Subscription Block JS File */
$(document).ready(function() {

});
